import { Box, Text } from '@mantine/core';
import type { ReactNode } from 'react';
import { OP_RESULT } from '../../domain/status.js';
import type { DiffGroup } from '../../domain/entityDiff.js';
import { DiffGroups, type DiffHeadings } from '../Diff/DiffGroups.js';
import { opDiff } from './pushSummary.js';
import type { PushOpRow } from './PushOps.js';

const UPDATE: DiffHeadings = ['Field', 'Before', 'After'];
const CREATE: DiffHeadings = ['Field', 'Before', 'Value'];

/**
 * What one operation writes, expanded in place under its row or card.
 *
 * An update shows the fields it writes, the environment's value before it beside the value it
 * becomes. An operation stored before ops carried before values shows the After column only. A
 * create is the whole record, field by field. A failure or conflict keeps its reason, one line.
 *
 * `rowAction` is the push review's per-field **Adopt ▾**, on an update it has not yet written.
 */
export const PushOpDetail = ({ op, rowAction }: { op: PushOpRow; rowAction?: (group: DiffGroup) => ReactNode }) => {
    const { groups, afterOnly } = opDiff(op);
    const headings = op.op === 'create' ? CREATE : UPDATE;
    return (
        <Box>
            {groups.length > 0 ? (
                <DiffGroups groups={groups} headings={headings} afterOnly={afterOnly} rowAction={rowAction} />
            ) : (
                <Text fz="xs" c="dimmed">
                    No fields written.
                </Text>
            )}

            {op.resultReason && (
                <Text fz="xs" c={OP_RESULT[op.result ?? 'pending'].color} lineClamp={1} title={op.resultReason} mt="xs">
                    {op.resultReason}
                </Text>
            )}
        </Box>
    );
};
